<div>{{ i18n + '.descriptionElement.text' | translate }}</div>
<div
	*ngIf="moduleDescription$ | async; let moduleDescription"
	[innerHTML]="moduleDescription"
></div>
<button
	[label]="i18n + '.startButton.label' | translate"
	(click)="onStartClick()"
	class="self-end"
	pButton
></button>
